export default __webpack_public_path__ + "static/media/10.add9c7df.wav";